export default __webpack_public_path__ + "images/MI.699d062.png";